import { IEvolucaoPatrimonioResponse } from "../../requests/types";

export default class EvolucaoPatrimonio {
  constructor(readonly response: IEvolucaoPatrimonioResponse | undefined) {}

  getAnos(): string[] {
    const response = this.response;

    if (!response) return [];

    return Object.keys(response.dados);
  }

  getDataByAtivo(): number[] {
    const response = this.response;

    if (!response) return [];

    return Object.values(response.dados).map((dado) => dado.ativoCirculante);
  }

  getDataByReceita(): number[] {
    const response = this.response;

    if (!response) return [];

    return Object.values(response.dados).map((dado) => dado.receita);
  }

  getDataByCustosEDespesas(): number[] {
    const response = this.response;

    if (!response) return [];

    return Object.values(response.dados).map((dado) => dado.custoEDespesas);
  }

  getDataByAtivoNaoCirculante(): number[] {
    const response = this.response;

    if (!response) return [];

    return Object.values(response.dados).map((dado) => dado.ativoNaoCirculante);
  }

  getTotalAtivosCirculantesENaoCirculantes(): number[] {
    const response = this.response;

    if (!response) return [];

    return (
      Object.values(this.response?.dados || {}).map((dado) =>
        Number(dado.ativoTotal)
      ) || []
    );
  }

  getDataByPassivo(): number[] {
    const response = this.response;

    if (!response) return [];

    return Object.values(response.dados).map((dado) => dado.passivoCirculante);
  }

  getDataByPassivoNaoCirculante(): number[] {
    const response = this.response;

    if (!response) return [];

    return Object.values(response.dados).map(
      (dado) => dado.passivoNaoCirculante
    );
  }

  getTotalPassivosCirculantesENaoCirculantes(): number {
    const response = this.response;

    if (!response) return 0;

    return this.getLastYearThatHasData().data?.passivoTotal || 0;
  }

  getTotalPatrimonioLiquidoUltimoAnoPossuiInformacao(): number {
    const response = this.response;

    if (!response) return 0;

    return this.getLastYearThatHasData().data?.patrimonioLiquido || 0;
  }

  getDataByResultadoAtivo(): number[] {
    const response = this.response;

    if (!response) return [];

    return Object.values(response.dados).map((dado) => dado.ativoTotal);
  }

  getDataByResultadoPassivo(): number[] {
    const response = this.response;

    if (!response) return [];

    return Object.values(response.dados).map((dado) => dado.passivoTotal);
  }

  getTotalPassivoAtivo(): number[] {
    const response = this.response;

    if (!response) return [];

    return (
      Object.values(this.response?.dados || {}).map((dado) =>
        Number(dado.passivoTotal)
      ) || []
    );
  }

  getTotalPatrimonioLiquido(): number[] {
    const response = this.response;

    if (!response) return [];

    return (
      Object.values(this.response?.dados || {}).map((dado) =>
        Number(dado.patrimonioLiquido)
      ) || []
    );
  }

  handleAlertPatrimonioLiquidoNegativo(): boolean {
    const response = this.response;

    if (!response) return false;

    return (
      (this.response?.empresasComPatrimonioLiquidoNegativo.length || 0) > 0
    );
  }

  handleAlertAtivoPassivoZero(): boolean {
    const response = this.response;

    if (!response) return false;

    return (this.response?.empresasComPassivoEAtivoZero || 0) > 0;
  }

  hasEvolucaoPatrimonial(): boolean {
    const response = this.response;

    if (!response) return false;

    return (response?.justificativaParimonial?.length || 0) > 0 ? true : false;
  }

  hasJustificativaResultado(): boolean {
    const response = this.response;

    if (!response) return false;

    return (response?.justificativaResultado?.length || 0) > 0 ? true : false;
  }

  hasSemDemonstracao(): boolean {
    const response = this.response;

    if (!response) return false;

    return (response?.semDemonstracao?.length || 0) > 0 ? true : false;
  }

  handleTotalResultadoDespesasEReceitas(): number {
    const response = this.response;

    if (!response) return 0;

    const resultado =
      this.getLastYearThatHasData().data?.lucroLiquidoExercicio || 0;

    return resultado;
  }

  getLastYearThatHasData() {
    try {
      const [year, data] = Object.entries(
        this.response?.dados || {}
      ).reverse()[0];

      return {
        year,
        data
      };
    } catch (_e) {
      return {
        year: null,
        data: null
      };
    }
  }
}
